export default __webpack_public_path__ + "static/media/arrow-background.6cf20ef8.png";